import * as yup from 'yup';

export const PlatformSalaryTemplateSchema = yup.object().shape({
    salaryStart: yup.date()
        .required('Start date is required')
        .typeError('Start date is not valid'),
    salaryEnd: yup.date()
        .required('End date is required')
        .typeError('End date is not valid')
        .min(yup.ref('salaryStart'), 'End date must be greater than or equal to Start date'),
});
